import { AccountQuestionIcon } from './AccountQuestionIcon';

/**
 * author: Coffeemate
 * id 163F4ADF-F6CC-42D0-AEED-DB61351C624C
 * name account-question
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-question.svg
 * tags
 * - Account / User 
 */
export const PersonQuestionIcon = AccountQuestionIcon;
export default PersonQuestionIcon